import { render, staticRenderFns } from "./QuoteListTable.vue?vue&type=template&id=61c4044a&scoped=true&"
import script from "./QuoteListTable.vue?vue&type=script&lang=js&"
export * from "./QuoteListTable.vue?vue&type=script&lang=js&"
import style0 from "./QuoteListTable.vue?vue&type=style&index=0&id=61c4044a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c4044a",
  null
  
)

export default component.exports